// extracted by mini-css-extract-plugin
export default {"label":"label--NExT2msrBj","disabled":"disabled--G3RpqBocRC","small":"small--qe9GiAwIBK","switch":"switch--s8wD-Fpng8"};